import styles from './Zebra.module.scss'
import Contact from '../pages/Contact'
import BestPractice from '../pages/BestPractice'
import Features from '../pages/Features'
import Introduction from '../pages/Introduction'
import Top from '../pages/Top'
import Flow from '../pages/Flow'

import QA from '../pages/QA'
import CallToAction from '../pages/CallToAction'
import Architecture from '../pages/Architecture'
import { useRef } from 'react'
import useScrollHideContact from '../hooks/useScrollHideContact'
import PriceList from './ZebraPriceList'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import NewsLp from 'components/LP/NewsLp/NewsLp'

const ContactFormId = '122b1fb2-c86f-413e-87cc-6a1ebeea3d8f'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '/services' },
  { name: 'ZEBRA', url: '#' },
]

const TopContents = {
  smallTitle: '顧客ニーズにマッチした次世代型CRMプッシュ通知',
  title: ['ZEBRAで実現する', '最適なメッセージ配信'],
  text: '顧客属性DBを活用し、細やかなセグメント配信で効果的なコミュニケーションを実現します。',
  imgLink: '/images/LP/LP202407/Logo/LogoZEBRA.png',
}

const IntroductionContents = {
  title: '顧客とのコミュニケーションに、こんな課題はありませんか？',
  list: [
    {
      text: ['顧客の属性や行動に合わせたきめ細かいメッセージ配信ができていない'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsChat.svg',
    },
    {
      text: ['プッシュ通知の効果測定や分析が十分にできていない'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsGraphDown.svg',
    },
    {
      text: ['複数の配信方法や機能を使いこなせていない'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsMenuButton.svg',
    },
  ],
}
const BestPracticeContents = {
  heading: ['効果的な顧客コミュニケーションを目指す企業に', '最適なソリューションです'],
  text: [
    'ZEBRAは、顧客属性DBを活用した高度なセグメント配信を実現します。',
    '全件配信、セグメント配信、リスト配信など多彩な配信方法を提供し、顧客のニーズに合わせた最適なメッセージを届けることが可能です。',
    '当社の専門家チームが、お客さまのニーズに合わせた最適なZEBRA環境の設計から運用までをトータルでサポートします。',
  ],
}

const ArchitectureContents = {
  title: 'ZEBRA',
  imgLink: ['/images/img/img_thumbnail_dummy.png'],
}

const FeaturesContents = {
  title: 'ZEBRA',
  items: [
    {
      num: '01',
      itemTitle: '顧客属性DBを活用した細やかなセグメント配信',
      description:
        '顧客属性DBを持つことで、各顧客に最適なメッセージを届けることが可能です。管理画面から簡単に顧客属性や配信スケジュールを編集でき、きめ細かいターゲティングを実現します。',
      src: '/images/LP/LP202407/img/img01.jpeg',
    },
    {
      num: '02',
      itemTitle: '多彩な配信機能とカスタマイズ性',
      description:
        'セグメント配信、予約配信、自動定期配信など多彩な機能を提供。さらに、バッジ表示やロック画面通知など、iOS・Android両方に対応した機能で、効果的な通知を実現します。',
      src: '/images/LP/LP202407/img/img06.jpeg',
    },
    {
      num: '03',
      itemTitle: '詳細な分析機能と継続的な最適化',
      description:
        '開封率やプッシュからのコンバージョンなど、詳細な解析が可能です。これにより、配信効果を測定し、継続的に配信戦略を最適化することができます。',
      src: '/images/LP/LP202407/img/img05.jpeg',
    },
  ],
}

const FlowContents = [
  {
    num: 1,
    title: '現状分析',
    description: 'お客さまの顧客コミュニケーション戦略と課題を詳細に分析します。',
    src: '/images/LP/LP202407/Icon/BsBarChartLine.svg',
  },
  {
    num: 2,
    title: 'ZEBRA環境の設計',
    description: 'お客さまのニーズに合わせた最適なZEBRA環境を設計します。',
    src: '/images/LP/LP202407/Icon/BsDiagram3.svg',
  },
  {
    num: 3,
    title: '初期設定と導入',
    description: 'ZEBRA環境を構築し、既存システムとの連携をサポートします。',
    src: '/images/LP/LP202407/Icon/BsWindowSidebar.svg',
  },
  {
    num: 4,
    title: '運用サポートと継続的な最適化',
    description: '配信効果の分析と改善提案を行い、継続的な最適化をサポートします。',
    src: '/images/LP/LP202407/Icon/BsPersonCheck.svg',
  },
]

const FAQContents = [
  {
    num: 1,
    question: 'ZEBRAはどのような企業に適していますか？',
    answer:
      '顧客とのコミュニケーションを重視し、効果的なプッシュ通知戦略を実現したい企業に適しています。特に、Eコマース、メディア、サービス業など、顧客エンゲージメントが重要な業種におすすめです。',
  },
  {
    num: 2,
    question: '既存のCRMシステムとの連携は可能ですか？',
    answer:
      'はい、可能です。当社の専門チームが、お客さまの既存システムとZEBRAとの最適な連携方法を提案し、スムーズな導入をサポートします。',
  },
  {
    num: 3,
    question: 'カスタマイズは可能ですか？',
    answer:
      'はい、お客さまのニーズに合わせたカスタマイズが可能です。ただし、カスタマイズの内容によっては別途費用が発生する場合があります。',
  },
  {
    num: 4,
    question: 'セキュリティ面はどうなっていますか？',
    answer:
      'ZEBRAは高度なセキュリティ対策を施しています。顧客データの保護や通信の暗号化など、安全な運用を実現します。具体的なセキュリティ対策については、お問い合わせください。',
  },
  {
    num: 5,
    question: '導入後のサポート体制はどうなっていますか？',
    answer:
      '導入後も、継続的にサポートします。定期的な効果分析や改善提案、技術的なサポートなど、お客さまのニーズに応じたサポートを提供します。',
  },
]

const inPocketList = [
  {
    image: '/images/inPocket/ZEBRA/push_zebra2.png',
    title: 'プッシュ通知成功の秘訣！効果的な配信ステップと機能別おすすめツール12選',
    date: '2024.9.12',
    href: 'https://www.i3design.jp/in-pocket/11713',
  },
  {
    image: '/images/inPocket/AWS CodePipeline/cicd_point.png',
    title: 'CI/CDとは？CI/CDツールを選ぶポイント7選＆ツール比較！',
    date: '2024.8.23',
    href: 'https://www.i3design.jp/in-pocket/11532',
  },
]

const topics = [
  {
    title:
      '特徴量エンジニアリングを使って生成AIによるUIデザインと画面レイアウトのアウトプットをコントロールする技術を開発',
    date: '2024年9月6日',
    src: '/pressrelease/3726',
  },
  {
    title: 'アート引越センターが提供する、AIが自動見積りをするアプリの開発支援をいたしました',
    date: '2024年5月21日',
    src: '/pressrelease/3369',
  },
  // { title: '', date: '', src: '' },
]

const CallToActionContents = {
  heading: ['ZEBRAで顧客との', 'コミュニケーションを最適化しませんか？'],
}

const Zebra: React.FC = () => {
  const contactRef = useRef<HTMLDivElement>(null)
  const contentsRef = useRef<HTMLDivElement>(null)

  useScrollHideContact(contactRef, contentsRef)
  return (
    <>
      <article className={styles.LPPage}>
        <div className={styles.contents} ref={contentsRef}>
          <Top contents={TopContents} paths={paths} />
          <Introduction contents={IntroductionContents} />
          <BestPractice contents={BestPracticeContents} />
          {/* <Architecture contents={ArchitectureContents} /> */}
          <Features contents={FeaturesContents} />
          <Flow contents={FlowContents} />
          <PriceList />
          <QA contents={FAQContents} />
          <NewsLp inPocketList={inPocketList} topics={topics} />
          <CallToAction contents={CallToActionContents} />
        </div>
        <div ref={contactRef} className={styles.contact_wrapper}>
          <Contact formId={ContactFormId} />
        </div>
        <div>
          <MailmagazineLink />
        </div>
      </article>
    </>
  )
}
export default Zebra
